import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatLegacyTooltipModule as MatTooltipModule } from '@angular/material/legacy-tooltip';
import { RouterModule, Routes } from '@angular/router';
import { IonicModule } from '@ionic/angular';

import { PipesModule } from 'src/app/shared/pipes/pipes.module';
import { UserCalibrationOverviewModule } from '../calibration/components/user-overview/user-overview.module';
import { AutoSaveModule } from '../shared/components/autosave/autosave.module';
import { Evaluation360ReportModule } from '../shared/components/full-reports/360-evaluation/360-evaluation-report.module';
import {
    FreeEvaluationReportModule
} from '../shared/components/full-reports/free-evaluation/free-evaluation-report.module';
import { HeadEditFinalAverageModule } from '../shared/components/head-evaluation/head-edit-final-average/head-edit-final-average.module';
import { ReopenHeadConfirmModule } from '../shared/components/head-evaluation/reopen-head-confirm/reopen-head-confirm.module';
import { QuestionAnswerModule } from '../shared/components/question-answer/question-answer.module';
import { QuestionTypesModule } from '../shared/components/question-types/question-types.module';
import { ReviewEvaluationsModule } from '../shared/components/review-evaluations/review-evaluations.module';
import { StepDescriptionModule } from '../shared/components/step-description/step-description.module';
import { UtilService } from '../shared/services/util.service';
import { EvaluatedUserListComponent } from './components/evaluated-user-list/evaluated-user-list.component';
import { SubordinateUserListComponent } from './components/subordinate-user-list/subordinate-user-list.component';
import { HeadEvaluationPage } from './head-evaluation.page';
import { HeadEvaluationService } from './head-evaluation.service';

const routes: Routes = [{
    path: '',
    component: HeadEvaluationPage
}];

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        IonicModule,
        RouterModule.forChild(routes),
        PipesModule,
        MatTooltipModule,
        StepDescriptionModule,
        Evaluation360ReportModule,
        QuestionTypesModule,
        QuestionAnswerModule,
        UserCalibrationOverviewModule,
        FreeEvaluationReportModule,
        AutoSaveModule,
        HeadEditFinalAverageModule,
        ReopenHeadConfirmModule,
        ReviewEvaluationsModule,
    ],
    declarations: [
        HeadEvaluationPage,
        SubordinateUserListComponent,
        EvaluatedUserListComponent
    ],
    providers: [
        HeadEvaluationService,
        UtilService,
    ]
})
export class HeadEvaluationModule {
}
